export default {"src":"/_next/static/media/ico_heart-fill.0c36efa4.svg","height":24,"width":25};